import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { Subscription } from 'rxjs';
import { GeneralService } from '@gs-2.0/core';

const DEFAULT_FORMAT = 'MM/dd/yyyy';

@Pipe({
  name: 'gsDateFormat',
  standalone: true,
  pure: false,
})
export class DateFormatPipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;

  constructor(
    private generalService: GeneralService,
    private cdr: ChangeDetectorRef,
  ) {
    this.subscription = this.generalService.settings$.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  transform(value: string | number | Date | null | undefined): string {
    if (value === null || value === undefined || value === '') return '';
    try {
      return formatDate(value, this.getDateFormat(), 'en-US');
    } catch {
      return String(value);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getDateFormat(): string {
    const config = this.generalService.settings?.response.globalConfig ?? [];
    return config.find(c => c.key === 'dateFormat')?.value || DEFAULT_FORMAT;
  }
}
